import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';
import { DateTime } from 'luxon';
import {
  TimeSignalClassification,
  BasicTimeSignalsCountQuery,
  useBasicTimeSignalsCountQuery
} from 'graphql/types';

export const useBasicTimeSignalsCount = (
  startDate?: DateTime | null | undefined
): {
  data: BasicTimeSignalsCountQuery | undefined;
  loading: boolean;

  error: ApolloError | undefined;
} => {
  const params = useMemo(
    () => ({
      inputUnClassified: {
        filter: {
          fromDate: startDate?.toISODate(),
          classifications: [TimeSignalClassification.Unclassified]
        }
      },
      inputAccepted: {
        filter: {
          fromDate: startDate?.toISODate(),
          classifications: [TimeSignalClassification.Accepted]
        }
      }
    }),
    [startDate]
  );
  const { data, error } = useBasicTimeSignalsCountQuery({
    variables: params
  });

  return useMemo(() => ({ data, loading: Boolean(!data), error }), [
    data,
    error
  ]);
};
